/* JOB PAGE — sticky apply bar on phones: appears after 360px of scroll, hides once the form is in view.
   Source: Website/careers/tws-job-page/js/job.js minus the mobile menu, mock file inputs and preview states. */
(function () {
  function boot() {
    var bar = document.querySelector('.tws-job .apply-bar');
    var form = document.getElementById('apply');
    if (!bar || !form || bar.dataset.init) return;
    bar.dataset.init = '1';
    function onScroll() {
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      var formIn = form.getBoundingClientRect().top < window.innerHeight * 0.85;
      document.body.classList.toggle('tws-job-bar-on', y > 360 && !formIn);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
